//src/Pages/Optical/OpticalForm.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DeviceAuthorization from "./DeviceAuthorization";
import { Button } from "primereact/button";
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';


export const OpticalForm = ({ formUserData, setFormUserData, onSaveDetails, onDeleteLogo, onClose ,kc }) => {
    const { t } = useTranslation();
    const { storeName, addressStreet, addressCity,addressZipCode, addressEmail, phoneNumber, logo } = formUserData;
    const [logoUrl, setLogoUrl] = useState(logo ? `data:image/png;base64,${logo}` : 'data:image/png;base64,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')

    const deleteLogo = async () => {
        onDeleteLogo()
        setFormUserData({
            ...formUserData,
            [ 'logo' ]: ''
        })
        setLogoUrl('');
    };

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        //console.log('onInputChange', name, value)
        setFormUserData({
            ...formUserData,
            [ name ]: value
        })
    }

    const handleLogoUpload = ({files}) => {
        const file = files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            // setLogo(reader.result.split(',')[1]); // Save base64 encoded part
            setFormUserData({
                ...formUserData,
                [ 'logo' ]: reader.result.split(',')[1]
            })
            setLogoUrl(reader.result); // Update display
        };
        reader.readAsDataURL(file);
    };


    return (
        <div className="account-settings text-left overflow-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 m-0">

                <label className="text-sm sm:text-base	uppercase my-auto">{ t('Name') }:</label>
                <InputText name="storeName" className={ classes } value={ storeName } onChange={ onInputChange } placeholder={t('Name')} />

                <label className="text-sm sm:text-base	uppercase my-auto">{ t('Address') }:</label>
                <InputText name="addressStreet" className={ classes } value={ addressStreet } onChange={ onInputChange } placeholder={t('Address')}/>

                <label className="text-sm sm:text-base	uppercase my-auto">{ t('City') }:</label>
                <InputText name="addressCity" className={ classes } value={ addressCity } onChange={ onInputChange } placeholder={t('City')}/>

                <label className="text-sm sm:text-base	uppercase my-auto">{ t('ZipCode') }:</label>
                <InputText name="addressZipCode" className={ classes } value={ addressZipCode } onChange={ onInputChange } placeholder={t('ZipCode')}/>


                <label className="text-sm sm:text-base	uppercase my-auto">{ t('Telephone') }:</label>
                <InputText name="phoneNumber" className={ classes } value={ phoneNumber } onChange={ onInputChange } placeholder={t('Telephone')} />

                <label className="text-sm sm:text-base	uppercase my-auto">{ t('Email') }:</label>
                <InputText name="addressEmail" className={ classes } value={ addressEmail } onChange={ onInputChange } placeholder={t('Email')} />

                <label className="uppercase my-auto">{ t('Logo') }</label>
                <div className="flex my-3">
                    { logoUrl && (
                        <img src={ logoUrl } alt="Store Logo" style={{ width: '100px' }} />
                    )}
                    <FileUpload
                        auto={true}
                        mode="basic"
                        chooseOptions={{ iconOnly: true, icon: 'pi pi-upload' }}
                        accept="image/*"
                        customUpload={true}
                        uploadHandler={ handleLogoUpload }
                        className="my-auto mx-3 optical-file-upload"
                    />
                    { logoUrl && (
                        <>
                            <Button
                                icon="pi pi-trash"
                                className="delete-button overflow-visible"
                                onClick={ deleteLogo }
                            />
                        </>
                    )}
                </div>
            </div>

            <DeviceAuthorization kc={kc}/>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-3 m-0">
                <div className="text-center sm:text-right"> <button className="btn-1 w-2/4" onClick={ onSaveDetails }>{ t('Save') }</button> </div>
                <div className="text-center sm:text-left"><button className="btn-2 w-2/4" onClick={ onClose }>{ t('Cancel') }</button></div>
            </div>

        </div>
    )
}

const classes = `text-xs p-2 col-span-1 md:col-span-2 w-48 sm:60 md:w-72 lg:w-80 xl:w-80 2xl:w-96`
